<template>
    <div id="modal-calculator-sent" aria-hidden="true" class="modal modal-calculator calculator-scoped-sent">
        <div tabindex="-1" class="modal-wrapp">
            <div role="dialog" aria-modal="true" class="modal-body">
                <a href="#" class="modal-close-btn" aria-label="Закрыть" data-modal-close>
                    <svg width="12" height="12">
                        <use xlink:href="#icon-close"/>
                    </svg>
                </a>
                <div class="calculator-sent-body">
                    <div class="calculator-sent-title h2">Спасибо за заказ!</div>
                    <div class="calculator-sent-desc">Наш менеджер свяжется с Вами<br> в ближайшее время</div>
                    <div class="calculator-sent-product">Заказ №{{ formattedOrderId }}</div>
                    <div class="calculator-sent-info">
                        <div class="calculator-sent-info-section">
                            <div class="calculator-sent-info-section-title h3">Состав заказа:</div>
                            <ul class="calculator-selected-list">
                                <li v-for="product in cart">
                                    <div class="calculator-selected-list-title">
                                        <span>{{ product['NAME'] }}</span>
                                    </div>
                                    <div class="calculator-selected-list-data">{{ product['QUANTITY'] }} шт.</div>
                                </li>
                            </ul>
                        </div>
                        <div class="calculator-total">
                            <div class="calculator-total-title">Стоимость:</div>
                            <div class="calculator-total-cost">
                                <span class="h2">{{ totalSummary }}</span> руб.
                            </div>
                        </div>
                    </div>
                    <!--<ul class="calculator-sent-action-links">
                        <li>
                            <a href="#" class="calculator-cart-action-link"
                                @click.prevent="pdfCalculator()">
                                <div class="calculator-cart-action-link-icon">
                                    <svg width="24" height="24">
                                        <use xlink:href="#icon-document"/>
                                    </svg>
                                </div>
                                <div class="calculator-cart-action-link-title">
                                    Сформировать PDF
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#" class="calculator-cart-action-link">
                                <div class="calculator-cart-action-link-icon">
                                    <svg width="24" height="24">
                                        <use xlink:href="#icon-copy"/>
                                    </svg>
                                </div>
                                <div class="calculator-cart-action-link-title">
                                    Скопировать ссылку на расчет
                                </div>
                            </a>
                        </li>
                    </ul>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalCalculatorSent",
    data() {
        return {
            orderId: '',
            formattedOrderId: '',
            cart: [],
            totalSummary: 0,
        }
    },
    mounted() {
        this.emitter.on('order-send-result', data => {
            this.orderId = data.orderId;
            this.formattedOrderId = String(data.orderId).match(/.{1,3}/g).join('-');
            this.cart = data.cart;
            this.totalSummary = new Intl.NumberFormat('ru-RU').format(data.totalSummary);
        });
    },
    methods: {
        pdfCalculator() {
            window.open(location.pathname + '?make_calculator_pdf=yes&order_id=' + this.orderId);
        }
    }
}
</script>

<style scoped>

</style>